import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { updateDriveItem } from '../../DriveItemList/actions';
import { getIsAccountManagerOrAdmin } from '../../ProfilePage/selectors';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import ApiUtils from '../../../utils/api';
import RoutesUtils from '../../../utils/routes';
import DriveItemUtils from '../../../utils/driveItem';
import store from '../../../store';
import { RoutePath } from '../../../routes/constants';

export const getResourceMeta = (resourceId: number) => async (dispatch: Dispatch<StoreState>, getState: () => StoreState): Promise<Api.DriveItem> => {
	const {
		driveList: { driveItems },
		editor: { parentFolderId },
		galleryInfos: { config: { applicationGallery } },
	} = getState();

	let resource = driveItems[resourceId];

	if (!resource) {
		// a case when editor is loaded directly (in web version)
		if (!parentFolderId) {
			// this call is needed to get privateDirId
			await ApiUtils.getMeta(applicationGallery);

			const {
				driveList,
				galleryInfos: { config },
			} = getState();
			const isAccountManagerOrAdmin = getIsAccountManagerOrAdmin(getState());
			const ancestorId = isAccountManagerOrAdmin
				? config.applicationGallery
				: Utils.getPrivateDirId(driveList, config);
			resource = await ApiUtils.getMeta(resourceId, true, ancestorId);
		// a case when redirect to newly created publication
		} else {
			resource = await ApiUtils.getMeta(resourceId);

			// a case when resource is actually outside of application (modifiable publication)
			if (DriveItemUtils.getParentFolderId(resource) !== parentFolderId) {
				resource.linkParentId = parentFolderId;
			}
		}

		dispatch(updateDriveItem(resource));
	}

	return resource;
};

// this check is used to prevent some actions in case user left Editor before it was loaded
export const isEditorOpened = (state?: StoreState): boolean => {
	const { routerParamsHistory } = state || store.getState();
	const currentRoute = RoutesUtils.getCurrentRoute(routerParamsHistory);
	return currentRoute.includes(RoutePath.Editor);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/actions/utils.ts